import { navLinks, siteDate } from "@/mocks/blackmole";

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100/80">
      <div className="mx-auto w-full max-w-[1240px] px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-fire-fill text-base"></i>
              </span>
              <span className="font-heading text-lg font-black text-foreground-950">
                暴走<span className="text-primary-600">黑料</span>
              </span>
            </div>
            <p className="mt-3 max-w-sm text-sm leading-relaxed text-foreground-600">
              一座把全网突发爆料收进同一条快讯流的编辑台：今日更新、正在追踪、抢先版进度，
              一张单页看明白。
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <span className="rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
                更新状态：在线
              </span>
              <span className="rounded-md bg-secondary-100 px-2.5 py-1 text-xs font-medium text-secondary-900">
                信源监测：9 路
              </span>
            </div>
          </div>

          <nav className="md:col-span-4" aria-label="站内导航">
            <h3 className="text-sm font-semibold text-foreground-950">快速入口</h3>
            <ul className="mt-3 grid grid-cols-2 gap-x-4 gap-y-2">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="inline-flex items-center gap-1 text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    <i className="ri-corner-right-down-line text-xs text-foreground-300"></i>
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="md:col-span-3">
            <h3 className="text-sm font-semibold text-foreground-950">追踪分区</h3>
            <ul className="mt-3 flex flex-col gap-2">
              {["圈内 · 台前幕后", "财经 · 资本商战", "社会 · 现场直击", "科技 · 数码前线"].map((z) => (
                <li key={z}>
                  <a
                    href="#zones"
                    className="text-sm text-foreground-600 transition-colors hover:text-primary-700"
                  >
                    {z}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-background-200 pt-5">
          <p className="text-xs leading-relaxed text-foreground-500">
            声明：本站内容均为对公开网络信息的整理与追踪记录，不作主观定论；凡涉个人名誉与隐私的条目，
            将依据公开资料与平台处理规则及时核实与下架。抢先版与快讯内容仅供信息整理参考，请以官方与正规渠道为准。
          </p>
          <div className="mt-4 flex flex-col justify-between gap-3 sm:flex-row sm:items-center">
            <p className="text-xs text-foreground-500">
              © 2026 暴走黑料 · 转载需注明来源 · 最后更新 {siteDate} 09:42
            </p>
            <a
              href="#top"
              className="inline-flex items-center gap-1.5 self-start whitespace-nowrap text-xs font-medium text-foreground-500 transition-colors hover:text-primary-700 sm:self-auto"
            >
              <i className="ri-arrow-up-line text-xs"></i>
              回到顶部
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}